import { render, staticRenderFns } from "./programPacksPage.vue?vue&type=template&id=7604f664&scoped=true&"
import script from "./programPacksPage.vue?vue&type=script&lang=ts&"
export * from "./programPacksPage.vue?vue&type=script&lang=ts&"
import style0 from "./programPacksPage.vue?vue&type=style&index=0&id=7604f664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7604f664",
  null
  
)

export default component.exports